import React from "react";
import { useTranslation } from "react-i18next";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import PrivacyPolicy from "../components/policiesPage/PrivacyPolicy";
import Impressum from "../components/policiesPage/Impressum";

function PoliciesPage() {
  const { t } = useTranslation();

  const tocLinkClass =
    "inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:border-primary/35 hover:bg-primary/5 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:border-primary-light/40 dark:hover:bg-primary-light/10 dark:hover:text-primary-light dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-900";

  return (
    <TailwindPageWrapper>
      <main
        id="policies-main"
        className="bg-slate-50/80 pb-16 pt-10 transition-colors dark:bg-slate-900 md:pb-20 md:pt-12"
      >
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <header className="mb-10 text-center md:mb-12">
            <h1 className="relative mb-6 inline-block text-pretty text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl">
              {t("policiesPage.pageTitle")}
              <span
                className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
                aria-hidden
              />
            </h1>
            <nav
              className="flex flex-wrap items-center justify-center gap-2 sm:gap-3"
              aria-label={t("policiesPage.toc_nav_aria")}
            >
              <a href="#privacy-policy" className={tocLinkClass}>
                {t("privacyPolicy.title")}
              </a>
              <a href="#impressum" className={tocLinkClass}>
                {t("impressum.title")}
              </a>
            </nav>
          </header>
        </div>
        <PrivacyPolicy />
        <Impressum />
      </main>
    </TailwindPageWrapper>
  );
}

export default PoliciesPage;
